import {ua} from '../../../../util/user-agent';
import {SmartTable} from '../../../components/smart-table/smart-table.model';
import Clipboard from 'clipboard';


export class Controller {

    /** @ngInject */
    constructor(Alert,
                Authenticator,
                PasswordManagers,
                DestructiveOperationModal,
                $uibModal,
                SsoFactory,
                $scope,
                $state,
                $timeout,) {
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.$state = $state;
        this.Alert = Alert;
        this.Authenticator = Authenticator;
        this.PasswordManagers = PasswordManagers;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.SsoFactory = SsoFactory;
        this.$timeout = $timeout;
    }

    $onInit() {
        Array.prototype.push.apply(this.authenticators,this.passwordManagers);
        this.publicUserAccounts = this.authenticators;
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
        this.st = new SmartTable();
        this.showExtensionAlert = false;
        this.showIEText = false;
        this.mustRenewOtp = false;
        const hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
        this.hasPass = false;
        this.showPassword = false;
        this.oldExtensionInstalled = hasExtensionInstalled201;
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
                this.Alert('success', 'global.data_copied')
            })
        })
    }

    copyCli(p) {
        this.getPassword(p);
    }

    getPassword(p) {
        return this.PasswordManagers.getPassword(p.id).then((data) => {
            p.password = data.password;
            p.hiddenPass = true;
            p.hasPass = true;
        })
    };

    getOtp(p) {
        return this.PasswordManagers.getOtp(p.id)
            .then((data) => {
                p.otp = data.otp;
            })
            .then(() => this.$timeout(30000))
            .then(() => p.mustRenewOtp = true);
    };

    renewOTP(p) {
        return this.PasswordManagers.getOtp(p.id)
            .then((data) => {
                p.otp = data.otp;
            })
            .then(() => p.mustRenewOtp = false)
            .then(() => this.$timeout(30000))
            .then(() => p.mustRenewOtp = true);
    }

    showPasswordF(p) {
        p.hiddenPass = p.hiddenPass === false;
    }

    showPassword(p) {
        this.PasswordManagers.getPassword(p.id).then((data) => {
            p.password = data.password;
        })
    };

    login(authenticator) {
        this.SsoFactory.authenticatorsSSO(authenticator);

        const hasExtensionInstalled = document.getElementById('extension-is-installed-v2.0.1') != null
            || document.getElementById('extension-is-installed-v2.1.0') != null;
        if (!hasExtensionInstalled && !document.getElementById("saaspass-extension-info")) {
            this.showExtensionAlert = true;
            $('html, body').animate({scrollTop: 0}, 'slow');
            this.showIEText = !(ua.isChrome() || ua.isOpera() || ua.isFirefox() || ua.isSafari());
        }
    }

    showDeleteAuthenticatorDP(id) {
        this.DestructiveOperationModal({
            titleKey: 'authenticators.messages.delete_authenticator_title',
            textKey: 'authenticators.messages.warning',
            http: {method: 'DELETE', url: `app/rest/authenticators/${id}`}
        }).then(() => {
            this.$state.reload(this.$state.current);
            this.Alert('success', 'authenticators.messages.delete');
        });
    }

    loginButtonVisible(authenticator) {
        if (this.oldExtensionInstalled && !authenticator.publicService.ssoInstructions) {
            return false;
        }
        if (authenticator.accountType === 'AUTHENTICATOR' && !authenticator.ssoEnabled) {
            return false;
        }
        const hasServiceUrl = !!(authenticator.publicService || {}).serviceUrl;
        const customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
        const hasCustomUrl = !!(authenticator.customLoginUrl || {}).serviceLoginUrl;
        return hasServiceUrl && !customUrlRequired || hasCustomUrl;
    };

    showDeletePasswordManagerDP(id) {
        this.$uibModal
            .open({component: 'userPasswordManagerConfirmRemove'}).result
            .then(() => {
                this.PasswordManagers.remove(id).then(() => {
                    this.Alert('success', 'authenticators.messages.deleteLoginItem');
                    this.$state.reload(this.$state.current);
                    // this.PasswordManagers.list().then(passwordmanagers => {
                    //     Array.prototype.push.apply(this.publicUserAccounts,passwordManagers);
                    // });
                });
            });
    };

}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public-user-accounts.controller.js